import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { PROFILE } from '../data/config';

const ContactContent = () => {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText(PROFILE.email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="contact-content">
      <h2>{'// ping_me.sh'}</h2>

      <div className="contact-links">
        <button onClick={copyEmail} className="contact-link">
          <span className="link-icon"><Mail size={20} strokeWidth={1.5} /></span>
          <span>{copied ? 'Copied!' : PROFILE.email}</span>
        </button>
        <a href={PROFILE.linkedin} target="_blank" rel="noopener noreferrer" className="contact-link">
          <span className="link-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
              <rect width="4" height="12" x="2" y="9"/>
              <circle cx="4" cy="4" r="2"/>
            </svg>
          </span>
          <span>linkedin.com/in/ossamaelhelali</span>
        </a>
        <a href={PROFILE.github} target="_blank" rel="noopener noreferrer" className="contact-link">
          <span className="link-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4"/>
              <path d="M9 18c-4.51 2-5-2-7-2"/>
            </svg>
          </span>
          <span>github.com/Ossama-E</span>
        </a>
      </div>

      <div className="terminal-contact">
        <p className="terminal-hint">
          $ echo "Let's build something cool together"
        </p>
      </div>
    </div>
  );
};

export default ContactContent;
